import type { AppsConfig } from "../../../lib/remote-config";
import { meetsMinVersion } from "../../../lib/version-gate";
import type { GetOneUsdActionId } from "../types";

export type GetOneUsdRemoteModes = NonNullable<
  NonNullable<AppsConfig["getOneUsd"]>["modes"]
>;

export type GetOneUsdRemoteMinVersions = NonNullable<
  NonNullable<AppsConfig["getOneUsd"]>["minVersions"]
>;

const REMOTE_MODE_KEYS: Record<
  GetOneUsdActionId,
  keyof GetOneUsdRemoteModes
> = {
  swap: "swap",
  bridge: "bridge",
  transfer: "transferCrypto",
};

/**
 * 목록에 보일지 여부. Swap/Bridge stay enabled when config is unavailable.
 * Transfer Crypto is opt-in and stays hidden until S3 explicitly enables it.
 */
export function isGetOneUsdActionVisible(
  action: GetOneUsdActionId,
  modes?: GetOneUsdRemoteModes,
): boolean {
  return modes?.[REMOTE_MODE_KEYS[action]] ?? action !== "transfer";
}

/**
 * 이 dapp-ui 버전에서 실행 가능한지. 미달이면 **숨기지 않고 비활성**으로 둔다 —
 * 항목이 조용히 사라지면 사용자는 기능이 없어진 줄 알지만, 비활성 + 안내면
 * "업데이트하면 쓸 수 있다"가 전달된다.
 */
export function isGetOneUsdActionSupported(
  action: GetOneUsdActionId,
  minVersions?: GetOneUsdRemoteMinVersions,
): boolean {
  return meetsMinVersion(minVersions?.[REMOTE_MODE_KEYS[action]]);
}

/** 노출 + 실행 가능(= 실제로 선택할 수 있는지). */
export function isGetOneUsdActionEnabled(
  action: GetOneUsdActionId,
  modes?: GetOneUsdRemoteModes,
  minVersions?: GetOneUsdRemoteMinVersions,
): boolean {
  return (
    isGetOneUsdActionVisible(action, modes) &&
    isGetOneUsdActionSupported(action, minVersions)
  );
}
